export const USER_STATUSES = {
  lead: 'lead',
  new: 'new',
  verified: 'verified',
  blocked: 'blocked',
  suspended: 'suspended',
  pending_review: 'pending_review',
};

export const USER_RESTRICTIONS = {
  add_cash: 'add_cash',
  investing: 'investing',
  withdraw: 'withdraw',
} as const;

export const padNumberUserId = (id: number, prefix: string = 'L', totalLength: number = 6) => {
  if (!id) return '';
  const zeros = new Array(totalLength).fill(0).join('');
  return `${id}`.length >= totalLength
    ? `${prefix} + ${id}`
    : `${prefix}${(zeros + id).slice(totalLength * -1)}`;
};

export const getInitials = (name: string): string => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  const [first, second] = words;
  if (!second) return first!.charAt(0).toUpperCase();
  return (first!.charAt(0) + second.charAt(0)).toUpperCase();
}

export const getFullName = (firstname?: string, lastname?: string, defaultName = '') => {
  if (firstname || lastname) {
    return `${firstname || ''} ${lastname || ''}`.trim();
  }
  return defaultName;
};
